export function notEmptyValue(value) {
  return value !== null && value !== undefined && value !== ''
}
